module.exports = __webpack_public_path__ + "static/media/coordination.271b8184.jpg";